import React from "react";
import {
  Answer,
  Heading,
  PageWrapper,
  Paragraph,
  QAWrapper,
  Question,
} from "./PagesStyles";
import { Navbar } from "../Components";
import { Parah } from "../Contents/ContentsStyles";
import { handleEmailClick } from "../Contents/TACContents/TAC_10";

const CSAEPolicy = () => {
  return (
    <PageWrapper>
      <Navbar />
      <Heading>
        Child Sexual Abuse and Exploitation (CSAE) Policy Prevention & Age
        Compliance Policy
      </Heading>
      <Paragraph>
        This policy outlines our platform’s absolute zero-tolerance stance on
        Child Sexual Abuse Material (CSAM) and Child Sexual Abuse and
        Exploitation (CSAE), alongside our age-gating compliance protocols under
        UK law.
      </Paragraph>
      <QAWrapper>
        <Question style={{ background: "var(--l-gray)", cursor: "default" }}>
          Age Restriction & Age Verification (13+)
        </Question>
        <Answer>
          <Parah>
            Our platform is strictly a 13+ environment. We do not permit or
            knowingly allow child users under the age of 13 to access or use our
            services. Age-Gating: In alignment with the ICO’s Children’s Code,
            we implement age-assurance measures at registration to prevent
            under-13s from creating accounts.
          </Parah>
          <Parah>
            Account Remediation: If we receive a report or have reasonable
            grounds to suspect a user is under the age of 13, the account will
            be immediately suspended pending review. If the user cannot verify
            they meet our minimum age requirement, the account will be
            permanently terminated and all personal data deleted in accordance
            with the UK GDPR.
          </Parah>
        </Answer>
        <Question style={{ background: "var(--l-gray)", cursor: "default" }}>
          Zero-Tolerance for CSAE & CSAM
        </Question>
        <Answer>
          <Parah>
            We prohibit any activity, communication, or content that exploits,
            harms, or sexualises children. This includes, but is not limited to:
            Illegal Content: The upload, transmission, sharing, or hosting of
            any imagery, video, text, or AI-generated material depicting the
            sexual abuse or exploitation of anyone under 18.
          </Parah>
          <Parah>
            Online Grooming & Harassment: Any behavior aimed at building
            relationships with minors for the purpose of sexual exploitation,
            manipulation, or solicitation. Child Endangerment: Encouraging,
            promoting, or facilitating harm or physical danger to minors.
          </Parah>
        </Answer>
        <Question style={{ background: "var(--l-gray)", cursor: "default" }}>
          Our Statutory Duties & Enforcement
        </Question>
        <Answer>
          <Parah>
            To comply with our "duty of care" under the UK Online Safety Act, we
            take a proactive approach to safety: Proactive Detection: We employ
            a combination of automated content moderation tools and trained
            human review teams to identify, flag, and intercept potential CSAE
            material. Swift Takedowns: Content identified as CSAM or CSAE is
            removed from our platform instantly.
          </Parah>
          <Parah>
            Systemic Bans: Users attempting to share, request, or facilitate
            CSAE will face an immediate, permanent ban, and we will take
            technical steps to prevent re-registration.
          </Parah>
        </Answer>
        <Question style={{ background: "var(--l-gray)", cursor: "default" }}>
          Mandatory Law Enforcement Reporting
        </Question>
        <Answer>
          <Parah>
            We do not merely delete illegal content; we actively work to protect
            children globally by coordinating with justice systems: NCA and CEOP
            Reporting: Any detected instances of CSAE, online grooming, or child
            exploitation will be preserved and reported immediately to the
            National Crime Agency (NCA) and the Child Exploitation and Online
            Protection (CEOP) command. International Cooperation: Where
            appropriate, we report directly to the National Center for Missing &
            Exploited Children (NCMEC) to ensure cross-border tracking of
            illegal material.
          </Parah>
          <Parah>
            Data Preservation: In accordance with UK law, relevant digital
            forensics, account details, and IP data will be securely preserved
            to assist law enforcement in criminal investigations
          </Parah>
        </Answer>
        <Question style={{ background: "var(--l-gray)", cursor: "default" }}>
          How to Report a Concern
        </Question>
        <Answer>
          If you see content or encounter a user on our platform that you
          believe is violating child safety laws, please act immediately: Use
          our in-app reporting tool by clicking the "Report" button on the
          user's profile or content block. Alternatively, contact our dedicated
          trust and safety team directly via email at{" "}
          <button
            onClick={handleEmailClick}
            style={{
              color: "#ff2146f0",
              background: "none",
              border: "none",
              padding: 0,
              cursor: "pointer",
              textDecoration: "underline",
            }}
          >
            info@talentsexplore.com
          </button>
        </Answer>
        <Answer>
          Note on Legal Next Steps: The UK Online Safety Act requires platforms
          to carry out a formal Children's Risk Assessment if your platform is
          likely to be accessed by children, even if you explicitly ban them.
          Ensure your engineering team integrates age-assurance mechanisms that
          satisfy Ofcom's guidelines to avoid compliance penalties
        </Answer>
      </QAWrapper>
    </PageWrapper>
  );
};

export default CSAEPolicy;
